import { Link } from "react-router-dom";
import { MapPin, Star, ArrowUp, BadgeCheck } from "lucide-react";
import { Listing, useApp } from "@/contexts/AppContext";
import FavoriteButton from "@/components/FavoriteButton";

export default function ListingCard({ listing }: { listing: Listing }) {
  const { isPromoted, isVerifiedOwner } = useApp();
  const promoted = isPromoted(listing.id);
  const verified = isVerifiedOwner(listing.ownerId);
  return (
    <Link to={`/anuncio/${listing.id}`} className="block bg-card rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all animate-fade-in border border-border/50 hover:border-primary/30 cursor-pointer">
      <div className="h-48 overflow-hidden relative">
        <div className="absolute top-2 right-2 z-10 bg-card/80 backdrop-blur-sm rounded-full">
          <FavoriteButton listingId={listing.id} />
        </div>
        {promoted && (
          <div className="absolute top-2 left-2 z-10 flex items-center gap-1 bg-amber-500 text-white text-[10px] font-bold px-2 py-1 rounded-full shadow">
            <ArrowUp className="h-3 w-3" /> Em destaque
          </div>
        )}
        <img
          src={listing.images[0]}
          alt={listing.title}
          className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
      </div>
      <div className="p-4 space-y-2">
        <div className="flex items-center gap-1.5 flex-wrap">
          <span className="text-xs font-medium bg-primary/10 text-primary px-2 py-0.5 rounded-full">
            {listing.category}
          </span>
          {verified && (
            <span className="inline-flex items-center gap-1 text-xs font-semibold bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">
              <BadgeCheck className="h-3 w-3" /> Verificado
            </span>
          )}
        </div>
        <h3 className="font-heading font-semibold text-card-foreground line-clamp-1">{listing.title}</h3>
        <div className="flex items-center gap-1 text-sm text-muted-foreground">
          <MapPin className="h-3.5 w-3.5" />
          {listing.city}, {listing.state}
        </div>
        <div className="flex items-center justify-between">
          <div>
            <span className="text-lg font-bold text-primary">R$ {listing.price}</span>
            <span className="text-xs text-muted-foreground ml-1">/{listing.priceUnit}</span>
          </div>
          {listing.rating > 0 && (
            <div className="flex items-center gap-1 text-xs text-muted-foreground">
              <Star className="h-3 w-3 fill-yellow-400 text-yellow-400" />
              {listing.rating.toFixed(1)}
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}
